<template>
    <select
        v-model="loginType"
        class="form-control"
        :class="{
            'bg-show-login'  : loginType === 'show',
            'bg-master-login': loginType === 'master',
        }"
        name="type"
        required
    >
        <option value="master">
            Master Login
        </option>
        <option v-if="false === this.forceMaster" value="show">
            Show Login
        </option>
    </select>
</template>
<style scoped>

    select {
        color: white;
        font-weight: bold;
        border: none !important;
        outline: none !important;
    }
    select:focus {
        color: white;
    }

</style>
<script>

    export default {
        name: 'LoginType',
        data() {
            return {
                loginType: this.forceMaster ? 'master' : this.type
            };
        },
        props     : {
            type: {
                type: String,
                default: 'master',
            },
            forceMaster: {
                type: Boolean,
                default: false,
            },
        },
        mounted() {
            this.initLoginType();
        },
        watch: {
            loginType(type) {
                this.persistLoginType(type);
            }
        },
        methods: {
            persistLoginType(type) {
                if (window.localStorage && !this.forceMaster) {
                    window.localStorage.setItem('com.777livecams.shows.login_type', type);
                }
            },
            initLoginType() {
                if (this.forceMaster) {
                    this.loginType = 'master';
                    return;
                }
                if (window.localStorage) {
                    const type = window.localStorage.getItem('com.777livecams.shows.login_type');
                    if (type === 'master' || type === 'show') {
                        this.loginType = type;
                    } else {
                        this.loginType = 'master';
                    }
                }
            }
        }
    }
</script>
